import React from "react";
import { Link, useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_API_URL;

export default function FamilyShell({ title, children, backTo = null }) {
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      await fetch(`${API}/logout`, {
        method: "POST",
        credentials: "include",
      });
    } finally {
      navigate("/family/login", { replace: true });
    }
  }

  return (
    <div className="min-h-screen bg-[#DEF1FF]">
      <div className="mx-auto max-w-5xl px-4 py-6 sm:px-6">
        <div className="mb-6 flex items-center justify-between gap-4">
          <div>
            <Link to="/family" className="text-sm font-medium text-blue-700 hover:text-blue-800">
              SteffiCare Familie
            </Link>
            <div className="mt-2 flex items-center gap-3">
              {backTo ? (
                <Link
                  to={backTo}
                  className="rounded-full bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
                >
                  ← Zurueck
                </Link>
              ) : null}
              <h1 className="text-3xl font-semibold text-gray-900">{title}</h1>
            </div>
          </div>
          <button
            type="button"
            onClick={handleLogout}
            className="rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
          >
            Logout
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
